import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod/v4";
import { LoadingSpinner } from "@/components/loading";
import { userInfoQueryOptions } from "@/lib/queries/userInfo";

const applyPromotionSearchSchema = z.object({
  buyPlanId: z.uuid().optional(),
  coupon: z.string().optional(),
});

export const Route = createFileRoute("/apply-promotion")({
  validateSearch: applyPromotionSearchSchema,
  component: () => (
    <div className="flex h-dvh w-dvw items-center justify-center">
      <LoadingSpinner size={48 * 2} />
    </div>
  ),
  pendingComponent: () => (
    <div className="flex h-dvh w-dvw items-center justify-center">
      <LoadingSpinner size={48 * 2} />
    </div>
  ),
  loaderDeps: ({ search }) => search,
  async loader({ deps: { buyPlanId, coupon }, context: { queryClient } }) {
    const userInfo = await queryClient.ensureQueryData(userInfoQueryOptions);
    if (userInfo.state === "logged_in")
      throw redirect({
        to: "/pricing",
        search: { coupon },
      });
    else
      throw redirect({
        to: "/auth/signup",
        search: {
          buyPlanId,
          buyPlanCoupon: coupon,
        },
      });
  },
});
